export * from './wall-type-6.component'